import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Message, Panel, Row } from 'rsuite'
//import { useParams } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import CheckboxRowHaveSubForm from '../../components/forms/checkboxRowForm/CheckboxRowHaveSubForm'
import EditButton from '../../components/buttons/editButton/EditButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { saveGoalTenYear } from '../../redux/actions/proposalGoal'
import { doneLoading, startLoading } from '../../utils/loading'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import CheckboxRowHaveSubView from '../../components/forms/checkboxRowForm/CheckboxRowHaveSubView'
import {
  getCloseOfProjectCoworkerForm,
  saveConfirmActualResult,
} from '../../redux/actions/closeOfProject'
import { cloneDeep } from 'lodash-es'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'

// import './styles.less'

export default function GoalTenYear(props) {
  const {
    showCommandButton,
    schema,
    checked,
    isConfirmActualResult = false,
    isEdit,
    onChangeIsEdit,
    numberOfInstallment,
    onSuccess = () => {},
  } = props
  const dispatch = useDispatch()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  // const [checkedConf, setCheckedConf] = useState(checked)

  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [formSchema, setFormSchema] = useState(schema)

  const handleUpdateGoalTenYear = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      console.log('request : ', request)
      const response = await saveGoalTenYear(projectId, request)

      if (response) {
        setFormSchema(response.model)

        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }

      onChangeIsEdit(false)
    } catch (e) {
      setIsError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)
    //const requiredData = getRequiredData(formSchema.validators)
    // console.log('requiredData', requiredData)
    // if (data.selectedList.length < 1) {
    //   setError('selectedList', {
    //     type: 'manual',
    //     message: requiredData.errorMessage,
    //   })
    // } else {
    let request = {
      optionSelected: data.selectedList,
      inputOther: data.inputOther,
      year: schema.bugetYear,
      version: schema.version,
    }

    handleUpdateGoalTenYear(request)
    // }

    // let optionSelected = formSchema.options.map((item) => {
    //   if (data[item.name]) {
    //     return item.value
    //   }
    //   return null
    // })

    // optionSelected = optionSelected.filter((item) => item !== null)

    // // const requiredData = getRequiredData(formSchema.validators)
    // if (requiredData && optionSelected.length === 0 && !data.inputOtherCheckbox) {
    //   setError('checkbox', {
    //     type: 'manual',
    //     message: requiredData.errorMessage,
    //   })
    //   return
    // }

    // let inputOtherValue = ''
    // if (data.inputOtherCheckbox) {
    //   inputOtherValue = data.inputOther
    // }

    // if (optionSelected) {
    //   formSchema.optionSelected = optionSelected
    // } else {
    //   formSchema.optionSelected = []
    // }

    // if (data.inputOther) {
    //   formSchema.inputOther.value = data.inputOther
    // } else {
    //   formSchema.inputOther.value = ''
    // }

    // handleUpdateGoalTenYear(formSchema)
  }

  const onSubmitConfActualResult = (data) => {
    console.log('onSubmitConfActualResult => ', data)

    let request = {
      optionSelected: data.selectedList,
      inputOther: data.inputOther,
      confType: 'GoalTenYear',
      targetLists: null,
      numberOfInstallment: numberOfInstallment,
      inputCriteria: null,
      year: schema.bugetYear,
      version: schema.version,
    }

    console.log('request => ', request)
    handleSaveConfirmActualResult(request)
  }

  const handleSaveConfirmActualResult = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await saveConfirmActualResult(projectId, request)
      console.log('response : ', response)
      if (response.success) {
        onSuccess(true)
        // location.reload()
        // const saveResp = await getCloseOfProjectCoworkerForm(projectId)
        //
        // let _formSchema = cloneDeep(formSchema)
        //
        // _formSchema.optionSelected = saveResp?.forms?.confirmActualResul?.goal?.goalTenYear?.optionSelected || null
        //
        // setCheckedConf(saveResp?.forms?.confirmActualResulChecked?.goalTenYearChecked || null)
        // setFormSchema(_formSchema)
        // await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
        onSuccess(false)
      }
    } catch (e) {
      setIsError(true)
      onSuccess(false)
    }

    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded={!isConfirmActualResult}
        header={formSchema.title}
        bordered
        collapsible
        defaultExpanded
      >
        <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

        {isEdit && showCommandButton ? (
          <CheckboxRowHaveSubForm
            isConfirmActualResult={isConfirmActualResult}
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        ) : (
          <CheckboxRowHaveSubView schema={formSchema} />
        )}

        {showCommandButton && (
          <>
            <hr />

            {isEdit ? (
              <>
                {isError && (
                  <Row style={{ marginBottom: 10 }}>
                    <Message
                      showIcon
                      type="error"
                      description={
                        'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                      }
                    />
                  </Row>
                )}

                {isConfirmActualResult ? (
                  <>
                    {checked && (
                      <Message
                        showIcon
                        type={checked.checkedType ? 'success' : 'error'}
                        description={
                          <div dangerouslySetInnerHTML={{ __html: checked.detail || '' }} />
                        }
                        style={{ marginBottom: 10 }}
                      />
                    )}

                    <SaveButton
                      icon="views-authorize"
                      onClick={handleSubmit(onSubmitConfActualResult)}
                      // disabled={!!checkedConf?.checkedType || isLoading}
                      disabled={isLoading}
                      children={'ยืนยันการดำเนินการจริง'}
                    />
                  </>
                ) : (
                  <>
                    <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading} />

                    <CancelButton onClick={() => onChangeIsEdit(false)} />
                  </>
                )}
              </>
            ) : (
              <>
                <EditButton onClick={() => onChangeIsEdit(true)}>
                  แก้ไข{formSchema.title}
                </EditButton>
              </>
            )}
          </>
        )}
      </Panel>
    </>
  )
}
